var map = {
	"./Android.svg": "GnSq",
	"./App.svg": "yTD/",
	"./Apple.svg": "buoi",
	"./Calendar.svg": "V/1g",
	"./Clock.svg": "bZVG",
	"./Download.svg": "/zJ5",
	"./Heart.svg": "ANsz",
	"./Search.svg": "1ofv",
	"./Settings.svg": "lVSU",
	"./ThumbsUp.svg": "VNJ8",
	"./Watchface.svg": "G3gH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DwwP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg \.svg$
// module id = DwwP
// module chunks = 1